import DropZoneMarketing from './DropZone'

export default DropZoneMarketing
